import Model from './Model';

/**
 * @example
 * const TrajectoryDocuments = Document.makeModel('/trajectories/13/files')
 * TrajectoryDocuments.collection() // returns all Documents of the trajectory 13
 */
export default class Document extends Model {
    returns;
    versions;
    creator;
    creator_id;
    trajectory_file_action;
    trajectory_file_action_id;
    trajectory_file_type;
    trajectory_file_type_id;
}



// WEBPACK FOOTER //
// ./src/models/Document.js